/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGenerateAiArticlesMutationRequest, ContentGenerateAiArticlesMutationResponse, ContentGenerateAiArticlesPathParams } from "../models/ContentGenerateAiArticles";

export function getContentGenerateAiArticlesUrl(id: ContentGenerateAiArticlesPathParams["id"]) {
  const res = { method: 'PUT', url: `/contents/${id}/generate-ai-articles` as const }  
  return res
}

/**
 * @summary Generate AI articles from media analysis
 * {@link /contents/:id/generate-ai-articles}
 */
export async function contentGenerateAiArticles(id: ContentGenerateAiArticlesPathParams["id"], data?: ContentGenerateAiArticlesMutationRequest, config: Partial<RequestConfig<ContentGenerateAiArticlesMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentGenerateAiArticlesMutationResponse, ResponseErrorConfig<Error>, ContentGenerateAiArticlesMutationRequest>({ method : "PUT", url : getContentGenerateAiArticlesUrl(id).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}